import BaseListStore from 'stores/BaseListStore';
import WebhookStore, { IWebhook } from 'stores/webook/WebhookStore';
import { SortDirection } from 'constants/SortDirection';
import { action, makeObservable } from 'mobx';
import { destroy, get, patch } from 'stores/_services/dataService';
import { IDataFetchOptions } from '../../types';

export default class WebhookListStore extends BaseListStore<WebhookStore> {
    constructor() {
        super({
            itemStore: WebhookStore,
            sortBy: 'name',
            sortDirection: SortDirection.DESC
        });

        makeObservable(this, {
            getWebhooks: action,
            getWebhook: action,
            deleteWebook: action,
            editWebhook: action
        });
    }

    async getWebhooks(args: IDataFetchOptions): Promise<void> {
        const shouldReset = this._updateListState(args);

        const options = {
            filter: {
                fields: ['id', 'name', 'method', 'description', 'option'],
                order: this.sort
            }
        };

        const { data } = await get('webhooks', options);

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data);
    }

    async getWebhook(webhookId: string): Promise<IWebhook | undefined> {
        const { data } = await get(`webhooks/${webhookId}/decrypted`);

        this._updateData(data);
        return data;
    }

    async deleteWebook(webhookId: string): Promise<void> {
        await destroy(`webhooks/${webhookId}`);

        this.clearItem(webhookId);
    }

    async editWebhook(webhook: Partial<IWebhook>): Promise<string | undefined> {
        try {
            await patch('webhooks', webhook);
        } catch (error: any) {
            return error.message;
        }
    }
}
